'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Op = require('./Op');

module.exports =
/*#__PURE__*/
function (_Op) {
  _inherits(WriteOp, _Op);

  function WriteOp() {
    _classCallCheck(this, WriteOp);

    return _possibleConstructorReturn(this, _getPrototypeOf(WriteOp).apply(this, arguments));
  }

  _createClass(WriteOp, [{
    key: "use",
    value: function use(cursor) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return darc.maybe(this.child.apply(this, [cursor].concat(args)).$save(), function () {
        return cursor;
      });
    }
  }]);

  return WriteOp;
}(Op);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NvdXJjZS9Xcml0ZU9wLmpzIl0sIm5hbWVzIjpbIk9wIiwicmVxdWlyZSIsIm1vZHVsZSIsImV4cG9ydHMiLCJjdXJzb3IiLCJhcmdzIiwiZGFyYyIsIm1heWJlIiwiY2hpbGQiLCIkc2F2ZSJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsS0FBS0MsUUFBUyxNQUFULENBQVg7O0FBR0FDLE9BQU9DLE9BQVA7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTs7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQSx3QkFFTUMsTUFGTixFQUV3QjtBQUFBLHdDQUFQQyxJQUFPO0FBQVBBLFlBQU87QUFBQTs7QUFFdEIsYUFBT0MsS0FBS0MsS0FBTCxDQUFZLEtBQUtDLEtBQUwsY0FBWUosTUFBWixTQUF1QkMsSUFBdkIsR0FBOEJJLEtBQTlCLEVBQVosRUFBbUQsWUFBTTtBQUUvRCxlQUFPTCxNQUFQO0FBRUEsT0FKTSxDQUFQO0FBTUE7QUFWRjs7QUFBQTtBQUFBLEVBQXVDSixFQUF2QyIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxuY29uc3QgT3AgPSByZXF1aXJlKCAnLi9PcCcgKTtcblxuXG5tb2R1bGUuZXhwb3J0cyA9IGNsYXNzIFdyaXRlT3AgZXh0ZW5kcyBPcCB7XG5cblx0dXNlKCBjdXJzb3IsIC4uLmFyZ3MgKSB7XG5cblx0XHRyZXR1cm4gZGFyYy5tYXliZSggdGhpcy5jaGlsZCggY3Vyc29yLCAuLi5hcmdzICkuJHNhdmUoKSwgKCkgPT4ge1xuXG5cdFx0XHRyZXR1cm4gY3Vyc29yO1xuXG5cdFx0fSApO1xuXG5cdH1cblxufTtcbiJdfQ==